const DefaultPagination = {
  limit: 10,
  offset: 0,
};

export default DefaultPagination;
